import { render, staticRenderFns } from "./DropPlayerDialog.vue?vue&type=template&id=8c0a6552&scoped=true&"
import script from "./DropPlayerDialog.vue?vue&type=script&lang=js&"
export * from "./DropPlayerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0a6552",
  null
  
)

export default component.exports